var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgVideoUpload = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4586 18.0579C36.4586 27.7228 28.4183 35.5579 18.5001 35.5579C8.58182 35.5579 0.541504 27.7228 0.541504 18.0579C0.541504 8.39288 8.58182 0.557861 18.5001 0.557861C28.4183 0.557861 36.4586 8.39288 36.4586 18.0579Z",
    fill: "#2E63FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6723 25.6565C14.9481 25.7908 15.2239 25.8356 15.4997 25.8356C15.8215 25.8356 16.1892 25.746 16.465 25.5221L25.7503 19.3407C26.2099 19.0271 26.4857 18.4896 26.4857 17.9521C26.4857 17.4146 26.2099 16.877 25.7043 16.5635L16.419 10.5612C15.8674 10.2029 15.2239 10.2029 14.6264 10.4717C14.0748 10.7852 13.707 11.3227 13.707 11.9498V24.1335C13.753 24.8054 14.0747 25.3877 14.6723 25.6565Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideoUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/videoUpload.8f670b2a.svg";
export { ForwardRef as ReactComponent };